// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./vendor/vi-kon/laravel-admin/src/resources/assets/bootstrap-multiselect/jquery.bootstrap-multiselect.css
// module id = 314
// module chunks = 0